import React from 'react';
import PropTypes from 'prop-types';
import css from './CwDialog.scss';
import cx from 'classnames';

export const CwFlyoutPointerPosition = {
  TOP_LEFT: 'TOP_LEFT',
  TOP_RIGHT: 'TOP_RIGHT',
  BOTTOM_LEFT: 'BOTTOM_LEFT',
  BOTTOM_RIGHT: 'BOTTOM_RIGHT'
};

class CwDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      style: null
    };
    this._style = null;
  }

  getDialogPosition = (dialog) => {

    /* istanbul ignore next */
    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    /* istanbul ignore next */
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = ((width / 2) - (dialog.offsetWidth / 2));
    var top = ((height / 2) - (dialog.offsetHeight / 2));

    if(this.props.flyoutPointerPosition) {
      left = this.props.x;
      top = this.props.y;
    }

    switch (this.props.flyoutPointerPosition) {
      case CwFlyoutPointerPosition.TOP_LEFT:
        left -= 24;
        top += 8;
        break;
      case CwFlyoutPointerPosition.TOP_RIGHT:
        left += (-dialog.offsetWidth + 24);
        top += 8;
        break;
      case CwFlyoutPointerPosition.BOTTOM_LEFT:
        left -= 24;
        top += (-dialog.offsetHeight - 48);
        break;
      case CwFlyoutPointerPosition.BOTTOM_RIGHT:
        left += (-dialog.offsetWidth + 24);
        top += (-dialog.offsetHeight - 48);
        break;
      default:
        break;
    }

    return { top, left };
  };

  setDialogPosition = () => {
    let style = this._style;
    if (this.dialog) {
      style = { ...style, ...this.getDialogPosition(this.dialog) };

      this.setState({
        style: style
      });
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.setDialogPosition);
    this.setDialogPosition();
  };
  componentWillUnmount() {
    window.removeEventListener("resize", this.setDialogPosition);
  }
  render() {

    const dialogClass = cx({
      [css.modal]: !this.props.flyoutPointerPosition,
      [css.flyoutTopLeft]: this.props.flyoutPointerPosition === CwFlyoutPointerPosition.TOP_LEFT,
      [css.flyoutTopRight]: this.props.flyoutPointerPosition === CwFlyoutPointerPosition.TOP_RIGHT,
      [css.flyoutBottomLeft]: this.props.flyoutPointerPosition === CwFlyoutPointerPosition.BOTTOM_LEFT,
      [css.flyoutBottomRight]: this.props.flyoutPointerPosition === CwFlyoutPointerPosition.BOTTOM_RIGHT,
    });
    let style = this.props.style;
    
    style = {
      ...style,
      height: this.props.height,
      width: this.props.width,
      left: this.props.x,
      top: this.props.y,
      zIndex: this.props.zIndex
    };
    this._style = style;

    return (
      <div data-cwid={this.props.cwId}
        className={dialogClass}
        style={this.state.style}
        onFocus={this.props.onFocus}
        onBlur={this.props.onBlur}
        ref={(dialog) => this.dialog = dialog}
      >
        <div className={css.wrap}>

          <div className={css.header}>
            {this.props.header}
          </div>

          {this.props.subHeader ? <div className={css.subHeader}>{this.props.subHeader}</div> : null}

          {this.props.children ? <div className={css.content}>{this.props.children}</div> : null}

          {this.props.buttons ? <div className={css.buttons}> {this.props.buttons} </div> : null}

        </div>

      </div>
    );
  };
}

CwDialog.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  /**
   * Content to be shown in the Dialog
   */
  children: PropTypes.any,
  /**
   * Array of buttons aligned in the bottom right corner
   */
  buttons: PropTypes.arrayOf(PropTypes.element),
  /**
   * The primary header of the dialog box
   */
  header: PropTypes.string.isRequired,
  /**
   * Specifies the height of the dialog box
   */
  height: PropTypes.number,
  /**
   * Specifies the position of the fly-out pointer
   */
  flyoutPointerPosition: PropTypes.oneOf(
    [CwFlyoutPointerPosition.TOP_LEFT, CwFlyoutPointerPosition.TOP_RIGHT,
    CwFlyoutPointerPosition.BOTTOM_LEFT, CwFlyoutPointerPosition.BOTTOM_RIGHT]),
  /**
   * The secondary header of the dialog box
   */
  subHeader: PropTypes.string,
  /**
   * Specifies the width of the dialog box
   */
  width: PropTypes.number,
  /**
   * Specifies the x coordinate of the dialog box
   */
  x: PropTypes.number,
  /**
   * Specifies the y coordinate of the dialog box
   */
  y: PropTypes.number,
  /**
   * Specifies the z-index of the dialog box
   */
  zIndex: PropTypes.number,
  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: PropTypes.func,
  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: PropTypes.func
};

CwDialog.defaultProps = {
  zIndex: 1,
};

export default CwDialog;


// WEBPACK FOOTER //
// ./src/components/cwdialog/CwDialog.jsx